<!-- 待审批列表组件 -->
<template>
    <div class="pending-approval">
      <!-- 搜索和筛选 -->
      <el-form :inline="true" class="search-form" size="small">
        <el-form-item label="项目名称">
          <el-input
            v-model="searchForm.workName"
            placeholder="搜索项目名称"
            clearable
            @clear="handleSearch"
          />
        </el-form-item>
        <el-form-item label="建设单位">
          <el-input
            v-model="searchForm.buildCompany"
            placeholder="搜索建设单位"
            clearable
            @clear="handleSearch"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch" :loading="loading">
            搜索
          </el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
  
      <!-- 申请列表 -->
      <el-table
        :data="applyList"
        border
        v-loading="loading"
        class="apply-table"
        @sort-change="handleSortChange"
      >
        <el-table-column prop="id" label="申请ID" width="80" sortable="custom" />
        <el-table-column prop="WorkName" label="项目名称" min-width="150" show-overflow-tooltip />
        <el-table-column prop="build_company" label="建设单位" min-width="120" show-overflow-tooltip />
        <el-table-column prop="SubjectName" label="承接单位" min-width="120" show-overflow-tooltip />
        <el-table-column label="修改内容" min-width="100">
          <template slot-scope="scope">
            <el-tag size="small" type="info">
              修改{{ scope.row.changedCount || 0 }}项
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="applyUserName" label="申请人" width="100">
          <template slot-scope="scope">
            {{ scope.row.applyUserName || '用户' + scope.row.apply_user_id }}
          </template>
        </el-table-column>
        <el-table-column prop="apply_time" label="申请时间" width="150" sortable="custom">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.apply_time) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              @click="handleViewDetail(scope.row)"
            >
              查看详情
            </el-button>
            <el-button
              type="text"
              size="mini"
              style="color: #67C23A"
              @click="handleQuickApprove(scope.row)"
            >
              快速通过
            </el-button>
            <el-button
              type="text"
              size="mini"
              style="color: #F56C6C"
              @click="handleRejectDialog(scope.row)"
            >
              拒绝
            </el-button>
          </template>
        </el-table-column>
      </el-table>
  
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.current"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagination.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        class="pagination"
      />
  
      <!-- 快速拒绝对话框 -->
      <el-dialog
        title="拒绝申请"
        :visible.sync="rejectDialogVisible"
        width="400px"
        @closed="resetRejectForm"
      >
        <el-form ref="rejectForm" :model="rejectForm" :rules="rejectRules" label-width="80px">
          <el-form-item label="拒绝理由" prop="reviewRemark" required>
            <el-input
              type="textarea"
              v-model="rejectForm.reviewRemark"
              placeholder="请填写拒绝理由"
              :rows="4"
              maxlength="200"
              show-word-limit
            />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="rejectDialogVisible = false">取消</el-button>
          <el-button 
            type="danger" 
            @click="handleReject" 
            :loading="rejectLoading"
          >
            确认拒绝
          </el-button>
        </div>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import { getPendingApproveList, approveContractApply, rejectContractApply } from '../api';
  
  export default {
    name: 'PendingApproval',
    
    props: {
      // 可以接收外部参数
    },
    
    data() {
      return {
        loading: false,
        applyList: [],
        
        // 搜索表单
        searchForm: {
          workName: '',
          buildCompany: ''
        },
        
        // 分页
        pagination: {
          current: 1,
          size: 10,
          total: 0
        },
        
        // 排序
        sortField: 'apply_time',
        sortOrder: 'desc',
        
        // 拒绝对话框
        rejectDialogVisible: false,
        rejectLoading: false,
        rejectForm: {
          applyId: null,
          reviewRemark: ''
        },
        rejectRules: {
          reviewRemark: [
            { required: true, message: '请填写拒绝理由', trigger: 'blur' },
            { min: 3, message: '拒绝理由至少3个字符', trigger: 'blur' }
          ]
        }
      };
    },
    
    computed: {
    },
    
    created() {
      this.loadData();
    },
    
    methods: {
      // 加载数据
      async loadData() {
        this.loading = true;
        try {
          const params = {
            page: this.pagination.current,
            limit: this.pagination.size
          };
          
          // 添加搜索条件
          if (this.searchForm.workName) {
            params.workName = this.searchForm.workName;
          }
          if (this.searchForm.buildCompany) {
            params.buildCompany = this.searchForm.buildCompany;
          }
          
          // 添加排序
          if (this.sortField) {
            params.field = this.sortField;
            params.order = this.sortOrder;
          }
          
          const res = await getPendingApproveList(params);
          
          console.log('待审批列表API返回:', res);
          
          if (res.code === 0) {
            this.applyList = res.data || [];
            this.pagination.total = res.count || 0;
            console.log('加载成功，数据条数:', this.applyList.length, '总数:', this.pagination.total);
          } else {
            console.error('加载失败，返回码:', res.code, '消息:', res.msg);
            this.$message.error(res.msg || '加载失败');
          }
        } catch (error) {
          console.error('加载待审批列表异常:', error);
          console.error('错误详情:', error.response || error.message);
          this.$message.error('加载失败: ' + (error.message || '未知错误'));
        } finally {
          this.loading = false;
        }
      },
      
      // 搜索
      handleSearch() {
        this.pagination.current = 1;
        this.loadData();
      },
      
      // 重置搜索
      resetSearch() {
        this.searchForm = {
          workName: '',
          buildCompany: ''
        };
        this.pagination.current = 1;
        this.loadData();
      },
      
      // 排序变化
      handleSortChange({ prop, order }) {
        if (prop && order) {
          this.sortField = prop;
          this.sortOrder = order === 'ascending' ? 'asc' : 'desc';
        } else {
          this.sortField = 'apply_time';
          this.sortOrder = 'desc';
        }
        this.loadData();
      },
      
      // 分页大小变化
      handleSizeChange(size) {
        this.pagination.size = size;
        this.pagination.current = 1;
        this.loadData();
      },
      
      // 当前页变化
      handleCurrentChange(current) {
        this.pagination.current = current;
        this.loadData();
      },
      
      // 查看详情
      handleViewDetail(row) {
        this.$emit('show-detail', {
          applyId: row.id,
          canApprove: true
        });
      },
      
      // 快速通过
      async handleQuickApprove(row) {
        try {
          await this.$confirm('确定要通过此申请吗？', '提示', {
            confirmButtonText: '确定通过',
            cancelButtonText: '取消',
            type: 'warning'
          });
          
          const loading = this.$loading({
            lock: true,
            text: '正在处理...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          
          const res = await approveContractApply({
            applyId: row.id,
            reviewRemark: '快速审批通过'
          });
          
          loading.close();
          
          if (res.code === 0) {
            this.$message.success('审批通过');
            this.loadData();
            this.$emit('refresh');
          } else {
            this.$message.error(res.msg || '审批失败');
          }
        } catch (error) {
          if (error !== 'cancel') {
            this.$message.error('操作失败');
          }
        }
      },
      
      // 打开拒绝对话框
      handleRejectDialog(row) {
        this.rejectForm.applyId = row.id;
        this.rejectDialogVisible = true;
      },
      
      // 处理拒绝
      async handleReject() {
        try {
          await this.$refs.rejectForm.validate();
          
          this.rejectLoading = true;
          
          const res = await rejectContractApply({
            applyId: this.rejectForm.applyId,
            reviewRemark: this.rejectForm.reviewRemark
          });
          
          if (res.code === 0) {
            this.$message.success('已拒绝该申请');
            this.rejectDialogVisible = false;
            this.loadData();
            this.$emit('refresh');
          } else {
            this.$message.error(res.msg || '拒绝失败');
          }
        } catch (error) {
          if (error.name !== 'Error') {
            this.$message.error('操作失败');
          }
        } finally {
          this.rejectLoading = false;
        }
      },
      
      // 重置拒绝表单
      resetRejectForm() {
        this.rejectForm = {
          applyId: null,
          reviewRemark: ''
        };
        if (this.$refs.rejectForm) {
          this.$refs.rejectForm.clearValidate();
        }
      },
      
      // 格式化日期时间
      formatDateTime(datetime) {
        if (!datetime) return '-';
        const date = new Date(datetime);
        return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
      },
      
    }
  };
  </script>
  
  <style scoped>
  .pending-approval {
    padding: 10px;
  }
  
  .search-form {
    margin-bottom: 15px;
    padding: 15px;
    background: #f8f9fa;
    border-radius: 4px;
    border: 1px solid #ebeef5;
  }
  
  .apply-table {
    margin-bottom: 15px;
    font-size: 13px;
  }
  
  .pagination {
    text-align: right;
    padding: 10px 0;
  }
  
  .dialog-footer {
    text-align: right;
  }
  
  /* 响应式适配 */
  @media screen and (max-width: 768px) {
    .search-form {
      padding: 10px;
    }
    
    .apply-table {
      font-size: 12px;
    }
    
    ::v-deep .el-table__cell {
      padding: 4px 0;
    }
    
    ::v-deep .el-button--mini {
      padding: 4px 8px;
      font-size: 12px;
    }
  }
  </style>